import React from 'react';
import PropTypes from 'prop-types';
import Dialog from "@mui/material/Dialog";
import {DialogContent, Grid} from "@mui/material";
import {ReactComponent as CloseIcon} from "assets/img/wms/close.svg";
import DesktopPopUpTitle from "./component/DesktopPopUpTitle";
import {borderGrayColor} from "../../../../assets/jss/main";
import {red} from "@mui/material/colors";

DesktopPopup.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    position: PropTypes.string,
    overflow: PropTypes.string
};

function DesktopPopup({open, onClose, title, subtitle, position = 'inherit', overflow = 'inherit', ...props}) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={"sm"}
            fullWidth
            sx={{
                '& .MuiPaper-root ': {
                    margin: '16px',
                    position: position,
                    overflow: overflow
                },
            }}
        >
            <DialogContent
                sx={{ padding: '24px', position: position, overflow: overflow}}
            >
                <Grid container direction={"column"} gap={"32px"}>
                    <Grid container>
                        <Grid item>
                            <DesktopPopUpTitle
                                title={title}
                                subtitle={subtitle}
                            />
                        </Grid>
                        <Grid item sx={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            padding: '12px !important',
                        }}>
                            <CloseIcon
                                onClick={onClose}
                                style={{
                                    cursor: 'pointer',
                                }}
                            />
                        </Grid>
                    </Grid>
                    {props.children}
                </Grid>
            </DialogContent>
        </Dialog>
    );
}

export default DesktopPopup;